// extracted by mini-css-extract-plugin
module.exports = {"root":"oKU4K","collectionButton":"-Vcje","favoriteButton":"_255P_","downloadButton":"_1wuTE"};